import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LayoutState } from '@immosky/types';

export const selectLayoutState = createFeatureSelector<LayoutState>('layout');

export const selectIsMapVisible = createSelector(
  selectLayoutState,
  (layoutState: LayoutState) => layoutState.isMapVisible
);

export const selectIsMobileFilterOpen = createSelector(
  selectLayoutState,
  (layoutState: LayoutState) => layoutState.isMobileFilterOpen
);

export const selectResponsiveTarget = createSelector(
  selectLayoutState,
  (layoutState: LayoutState) => layoutState.responsiveTarget
);

export const selectIsLoadingSearchResults = createSelector(
  selectLayoutState,
  (layoutState: LayoutState) => layoutState.isLoadingSearchResults
);
